import React from 'react';
import { openIssueDrawer } from '../../data/pack-store';
import styles from './rca-banner.module.css';

/* Icons are the Figma 30907-108291 assets verbatim: alert-triangle
 * (stroke #D1242F, width 1.25) and the gradient AI-sparkle on View RCA.
 * DEVIATION from kaneai's RCABanner (which uses the red TestMuAIIcon in
 * both spots): the Figma node and the product screenshot both show these
 * two glyphs, so the design file wins here. */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function AlertTriangleIcon() {
  return /*#__PURE__*/_jsx("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    children: /*#__PURE__*/_jsx("path", {
      d: "M8.00039 5.54537L8.00039 9.54537M8.00039 11.5543V11.5454M6.60159 2.46297L1.32084 11.9683C0.728366 13.0348 1.49951 14.3454 2.71949 14.3454H13.281C14.501 14.3454 15.2722 13.0348 14.6797 11.9683L9.39895 2.46297C8.78927 1.36568 7.21119 1.36568 6.60159 2.46297Z",
      stroke: "#D1242F",
      strokeWidth: "1.25",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
}
function AiSparkleIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#ev-rca-sparkle-clip)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M13.9262 13.9266L11.0596 11.0599Z",
        fill: "url(#ev-rca-sparkle-a)"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.9262 13.9266L11.0596 11.0599M12.029 7.61555C11.7527 10.1155 9.63319 12.0599 7.05957 12.0599C4.29815 12.0599 2.05957 9.82135 2.05957 7.05992C2.05957 4.93289 3.38775 3.11606 5.26 2.39355",
        stroke: "url(#ev-rca-sparkle-b)",
        strokeWidth: "1.25",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10.4698 5.04592L10.0129 6.03611L9.32318 4.69706L9.24454 4.5718C9.1565 4.45393 9.04031 4.35892 8.90562 4.29635L7.53388 3.65828L8.44626 3.20234L10.4698 5.04592ZM10.5876 2.54127C10.6848 2.71687 10.8385 2.85503 11.0234 2.93254L12.3561 3.48989L11.4321 4.00487L9.42707 2.15966L9.84299 1.19827L10.5876 2.54127Z",
        stroke: "url(#ev-rca-sparkle-c)",
        strokeWidth: "1.25"
      })]
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "ev-rca-sparkle-a",
        x1: "13.9262",
        y1: "13.9266",
        x2: "-0.11078",
        y2: "8.83693",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0.0972577",
          stopColor: "#517ACD"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.4",
          stopColor: "#7F7BA5"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.75",
          stopColor: "#FF9A66"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#F1CBAF"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "ev-rca-sparkle-b",
        x1: "13.9262",
        y1: "13.9266",
        x2: "-0.11078",
        y2: "8.83693",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0.0972577",
          stopColor: "#517ACD"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.4",
          stopColor: "#7F7BA5"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.75",
          stopColor: "#FF9A66"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#F1CBAF"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "ev-rca-sparkle-c",
        x1: "13.5649",
        y1: "6.99574",
        x2: "5.13192",
        y2: "4.35033",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0.0972577",
          stopColor: "#517ACD"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.389423",
          stopColor: "#7F7BA5"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.75",
          stopColor: "#FF9A66"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#F1CBAF"
        })]
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "ev-rca-sparkle-clip",
        children: /*#__PURE__*/_jsx("rect", {
          width: "16",
          height: "16",
          fill: "white"
        })
      })]
    })]
  });
}

/**
 * Failed-test banner under the detail header (kaneai RCABanner port /
 * Figma 30907-108291), fed from the pack's failure record instead of the
 * insights API. One body line — the triage root cause (title fallback) —
 * plus the two actions. No "Generate RCA" state: packs are sealed, there
 * is nothing to generate.
 */
export function RcaBanner(_ref) {
  var _item$rootCause;
  var item = _ref.item,
    onViewFailedStep = _ref.onViewFailedStep;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.banner,
    role: "alert",
    children: [/*#__PURE__*/_jsx("span", {
      className: styles.iconWrap,
      children: /*#__PURE__*/_jsx(AlertTriangleIcon, {})
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.content,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.body,
        children: (_item$rootCause = item.rootCause) !== null && _item$rootCause !== void 0 ? _item$rootCause : item.title
      }), /*#__PURE__*/_jsxs("span", {
        className: styles.actions,
        children: [/*#__PURE__*/_jsx("button", {
          type: "button",
          className: styles.failedStepBtn,
          onClick: onViewFailedStep,
          children: "View failed step"
        }), /*#__PURE__*/_jsxs("button", {
          type: "button",
          className: styles.viewRcaBtn,
          onClick: function onClick() {
            return openIssueDrawer(item);
          },
          children: [/*#__PURE__*/_jsx(AiSparkleIcon, {}), "View RCA"]
        })]
      })]
    })]
  });
}